import { render, staticRenderFns } from "./TeamInsightsSkeleton.vue?vue&type=template&id=090cd18a&scoped=true"
import script from "./TeamInsightsSkeleton.vue?vue&type=script&lang=js"
export * from "./TeamInsightsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TeamInsightsSkeleton.vue?vue&type=style&index=0&id=090cd18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cd18a",
  null
  
)

export default component.exports